import { TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { mockData } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { ClientsCommentsSliderProps as Props } from './types';

export const ClientsCommentsSlider = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('ClientsCommentsSlider', className)}
      sx={SX.root}
      title={
        <Typography variant="body1" fontWeight={700}>
          Hear What Our Clients Say
        </Typography>
      }
      before={
        <Typography variant="body3" fontWeight={500}>
          We’ve helped these brands scale their sales, without the stress
        </Typography>
      }
      items={mockData}
      slideToShowDefaultSize={4}
      slideToShow={{ xs: 1, sm: 1, md: 1, lg: 4, xl: 4 }}
      render={(item: any) => (
        <Box sx={SX.box} key={item.key}>
          <Stack>
            <Typography variant="h6" fontWeight={600} color="primary.900">
              {item.quote}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ mt: 'auto' }}
          >
            <Stack direction="row" gap={1}>
              <Avatar
                size={40}
                src={item.image}
                alt={item.name}
                variant="rounded"
              />
              <Stack alignItems="flex-start">
                <Typography variant="body4" fontWeight={400}>
                  {item.name}
                </Typography>
                <TextEllipsis
                  width="140px"
                  textAlign="left"
                  variant="body2"
                  fontWeight={700}
                >
                  {item.title}
                </TextEllipsis>
              </Stack>
            </Stack>
            <Avatar
              size={40}
              src={item.logo}
              alt="Company Logo"
              variant="rounded"
            />
          </Stack>
        </Box>
      )}
      contentSx={SX.content}
    />
  );
});

ClientsCommentsSlider.displayName = 'ClientsCommentsSlider';
